module.exports = __webpack_public_path__ + "static/media/aggregator_leaf.c9f21541.svg";